import "./css/App.css";
import "./css/login.css";
import "./css/navbar.css";
import "./css/firstTable.css";
import "./css/footer.css";
import "./css/popups.css";
import "./css/clasificator.css";
import "./css/general.css";

// import Login from './components/Login';
import Navbar from "./components/Navbar";
import FirstTable from "./components/FirstTable";
import SecondScreen from "./components/SecondTable";
import Footer from "./components/Footer";

function App() {

  return (
    <div className="App">
      {/* <Login /> */}
      <Navbar />
      <FirstTable />
      {/* <SecondScreen /> */}
      <Footer />
    </div>
  );
}

export default App;
